import moment from 'moment'
import React from 'react'
import { images } from '../../images'
import { IPublicTicket } from '../../models'
import { LiteralsService } from '../../services'
import { TagComponent } from '../ServiceCheckbox/TagComponent'
import { StyledBanner, StyledList } from './styles'

interface IActiveTicketsListProps {
  tickets: IPublicTicket[]
  showServiceInfo?: boolean
}

interface IActiveTicketsBannerProps {
  tickets: IPublicTicket[]
}

const affairLabel = (ticket: IPublicTicket): string =>
  LiteralsService.getOrDefault(ticket.affair?.toLowerCase(), 'others', true)

export const ActiveTicketsList: React.FC<IActiveTicketsListProps> = ({ tickets, showServiceInfo = true }) => (
  <StyledList>
    {
      tickets.map((ticket) => (
        <li key={ ticket.id } className="active-ticket">
          {
            showServiceInfo && ticket.serviceInfo &&
            <div className="service">
              <TagComponent tag={ ticket.serviceInfo.tag } color={ ticket.serviceInfo.color } clickable={ false } />
              { ticket.serviceInfo.name && <span className="service-name">{ ticket.serviceInfo.name }</span> }
            </div>
          }
          <span className="affair">{ affairLabel(ticket) }</span>
          {
            ticket.expeditionDateTime &&
            <span className="expedition-time">
              { `${ LiteralsService.get('departure', true) } ${ moment(ticket.expeditionDateTime).format('DD/MM HH:mm') }` }
            </span>
          }
          { ticket.publicMessage && <p className="public-message">{ ticket.publicMessage }</p> }
        </li>
      ))
    }
  </StyledList>
)

export const ActiveTicketsBanner: React.FC<IActiveTicketsBannerProps> = ({ tickets }) => {
  if (!tickets.length) return null

  return (
    <StyledBanner role="alert">
      <header>
        <img src={ images.activeTicket } alt="" aria-hidden="true" />
        <span>{ LiteralsService.get('activeTickets.bannerTitle', true) }</span>
      </header>
      <ActiveTicketsList tickets={ tickets } showServiceInfo={ false } />
    </StyledBanner>
  )
}
